<template>
  <label class="switch-container">
    <input
      type="checkbox"
      :checked="modelValue"
      :disabled="disabled"
      @change="$emit('update:modelValue', $event.target.checked)"
    >
    <span
      class="switch"
      :style="cssProps"
    />
  </label>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    label: {
      type: String,
      default: 'label'
      // required: true,
    },
    modelValue: {
      default: false,
      type: [Boolean]
    },
    backgroundColor: {
      type: String,
      default: "#05421a"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup() {},
  computed: {
    cssProps(){
      return {
        '--switch-active-color': this.backgroundColor
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.switch-container {
  cursor: pointer;
  display: flex;
  align-items: center;
  width: fit-content;
}
.label {
  margin-left: 12px;
  color: #1a202c;
  /* Show an ellipsis if the text takes more than one line */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Visually hide the checkbox input */
input {
  opacity: 0;
  width: 0;
  height: 0;
  position: fixed;
  pointer-events: none;
}
.switch {
  --switch-container-width: 50px;
  --switch-size: calc(var(--switch-container-width) / 2);
  --light-gray: #e2e8f0;
  --gray: #cbd5e0;
  --dark-gray: #a0aec0;
  --teal: #4fd1c5;
  --dark-teal: #319795;
  /* Vertically center the inner circle */
  display: flex;
  align-items: center;
  position: relative;
  height: var(--switch-size);
  flex-basis: var(--switch-container-width);
  /* Make the container element rounded */
  border-radius: var(--switch-size);
  background-color: var(--light-gray);
  flex-shrink: 0;
  transition: background-color 0.25s ease-in-out;
}
.switch::before {
  content: "";
  position: absolute;
  /* Move a little bit the inner circle to the right */
  left: 1px;
  height: calc(var(--switch-size) - 4px);
  width: calc(var(--switch-size) - 4px);
  /* Make the inner circle fully rounded */
  border-radius: 9999px;
  background-color: white;
  border: 2px solid var(--light-gray);
  transition: transform 0.375s ease-in-out;
}
input:checked + .switch {
  background-color: var(--switch-active-color);
}
input:checked + .switch::before {
  background-color: white !important;
  /* Move the inner circle to the right */
  transform: translateX(
     25px
  );
}
input:focus + .switch::before {
  border-color: var(--gray);
}
input:focus:checked + .switch::before {
  @apply bg-default_secondary
}
input:disabled + .switch {
  background-color: var(--gray);
}
input:disabled + .switch::before {
  background-color: var(--dark-gray);
  border-color: var(--dark-gray);
}
</style>
